import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "dm_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setVisible(true); } catch {}
  }, []);

  const decide = (choice) => {
    try { localStorage.setItem(KEY, choice); } catch {}
    setVisible(false);
    window.dispatchEvent(new CustomEvent("dm:cookie-consent", { detail: { choice } }));
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[55] bg-[#0A0A0A] text-white"
    >
      <div className="max-w-[1600px] mx-auto px-4 lg:px-12 py-2.5 flex items-center justify-between gap-3">
        <p className="text-[11px] sm:text-xs text-white/70 leading-snug truncate">
          We use essential cookies only — optional analytics with your consent.{" "}
          <Link to="/privacy" className="underline underline-offset-2 hover:text-white whitespace-nowrap">Privacy</Link>
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <button
            data-testid="cookie-reject"
            onClick={() => decide("rejected")}
            className="text-[11px] uppercase tracking-[0.12em] px-3 py-1.5 border border-white/25 hover:border-white transition-colors"
          >
            Essential only
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => decide("accepted")}
            className="text-[11px] uppercase tracking-[0.12em] px-4 py-1.5 bg-white text-black hover:bg-zinc-200 transition-colors"
          >
            Accept
          </button>
          <button
            onClick={() => decide("rejected")}
            aria-label="Close"
            className="p-1 text-white/50 hover:text-white transition-colors"
          >
            <X size={14}/>
          </button>
        </div>
      </div>
    </div>
  );
}
